<template>
  <v-dialog v-model="show" persistent max-width="500">
    <v-card>
      <v-card-title class="headline error--text">
        <v-icon left color="error">receipt</v-icon>
        E-Fatura İptali
      </v-card-title>

      <v-card-text v-if="step === 1">
        <p class="mb-3">
          Bu siparişin e-faturasını iptal etmek üzeresiniz. Onaylamak için aşağıdaki
          <strong>sipariş numarasını</strong> kutuya yazın.
        </p>
        <v-text-field
          :value="orderNumber"
          label="Sipariş No"
          readonly
          outlined
          dense
          append-icon="content_copy"
          @click:append="copyNumber"
          hint="Kopyalamak için sağdaki simgeye tıklayın"
          persistent-hint
        ></v-text-field>
        <div v-if="copied" class="green--text caption mb-2">Kopyalandı ✓</div>
        <v-text-field
          v-model="typed"
          label="Sipariş numarasını buraya yazın / yapıştırın"
          outlined
          dense
          class="mt-2"
        ></v-text-field>
      </v-card-text>

      <v-card-text v-else>
        <p class="title mb-2">Emin misiniz?</p>
        <p>
          <strong>{{ orderNumber }}</strong> numaralı siparişin e-faturası iptal edilecek.
          Bu işlem geri alınamaz.
        </p>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Vazgeç</v-btn>
        <v-btn
          v-if="step === 1"
          color="error"
          :disabled="!typed || typed.trim() !== String(orderNumber).trim()"
          @click="step = 2"
        >Devam</v-btn>
        <v-btn
          v-else
          color="error"
          :loading="loading"
          @click="$emit('confirm')"
        >Onayla, İptal Et</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "InvoiceCancelDialog",
  props: {
    value: { type: Boolean, default: false },
    orderNumber: { type: [String, Number], default: "" },
    loading: { type: Boolean, default: false }
  },
  data() {
    return { step: 1, typed: "", copied: false };
  },
  computed: {
    show: {
      get() { return this.value; },
      set(v) { this.$emit("input", v); }
    }
  },
  watch: {
    value(v) {
      if (v) { this.step = 1; this.typed = ""; this.copied = false; }
    }
  },
  methods: {
    close() { this.$emit("input", false); },
    async copyNumber() {
      const text = String(this.orderNumber);
      try {
        await navigator.clipboard.writeText(text);
      } catch (e) {
        const el = document.createElement("textarea");
        el.value = text;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
      }
      this.copied = true;
      setTimeout(() => { this.copied = false; }, 1500);
    }
  }
};
</script>
